import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { PageList } from '~/layout';
import CardsList from './components/CardsList';
import EmployeeCreate from './components/EmployeeCreate';
import Filters from './components/Filters';
import EmployeeShow from './components/EmployeeShow';

import EmployeesTable from './components/EmployeesTable';
import { usePath, usePermissions } from '~/hooks';
import { NoPermission } from '~/components';
import { useEmployeesQuery } from '~/hooks/employees';

const EmployeesPage: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('employees');
  const { data, isLoading, isFetching, total } = useEmployeesQuery();
  const { changePath } = usePath();

  const hasAccess = usePermissions('business.employee.list');
  if (!hasAccess) return <NoPermission />;
  return (
    <>
      <EmployeeShow />
      <PageList
        header={{
          heading: t('team'),
          searchPlaceholder: t('searchPlaceholder'),
          onSearch: (name: string) => changePath({ filter: { name } }),
          queryParam: 'name',
          isFetching,
        }}
        filters={<Filters />}
        table={<EmployeesTable data={data} total={total} loading={isLoading} />}
        cards={<CardsList data={data} total={total} loading={isLoading} />}
        add={<EmployeeCreate />}
        defaultDisplayMode="cards"
      />
    </>
  );
};

export default EmployeesPage;
